import SliderWidget from './SliderWidget.svelte'
import { generateDataAttribute } from '../loader/utils'
import configModule from '../config'
const config = configModule()
const env = process.env.NODE_ENV

const mode = env || 'development'

const dataAttribute = generateDataAttribute(
  config.widgetTypeId,
  config.sleekSliderWidgetDocumentId
)

const target = document.querySelector(`[${dataAttribute}]`) || document.getElementById(config.legacySliderWidgetDocumentId)

const sliderWidget = (settingsResponse) => new SliderWidget({
  target,
  devtool: 'source-map',
  mode,
  props: {
    settingsResponse
  }
})

export default sliderWidget
